import {
  HttpEvent,
  HttpHandlerFn,
  HttpHeaders,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import {catchError, Observable, OperatorFunction, tap, throwError} from "rxjs";
import {inject, PLATFORM_ID, REQUEST} from "@angular/core";
import {isPlatformBrowser} from "@angular/common";
import {Router} from "@angular/router";
import {ModalService} from '../../oex-ui-kit/services/modal.service';
import {AuthService} from './auth.service';

// This is interceptor for SSR to pass http only cookies to server request from client
export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);
  const modal = inject(ModalService);
  const auth = inject(AuthService);

  // Checking for coins changes
  const checkCoins: OperatorFunction<HttpEvent<unknown>, HttpEvent<unknown>> = tap(event => {
    if (event instanceof HttpResponse && !(event as HttpResponse<any>)?.url?.includes('/api/state')) {
      checkCoinsFromResponse(auth, event.body);
    }
  });

  // Error processing
  const processError: OperatorFunction<HttpEvent<any>, any> = catchError((e, r) => {
    if (e.status === 503) {
      void modal.show({
        title: 'Error 503 Service Temporarily Unavailable.',
        message: 'Seems site currently in updating process.\nPlease try again in a few minutes.',
        buttons: [
          {text: 'Close', close: true, primary: true}
        ]
      });
    }
    if (e.status === 404) {
      void router.navigateByUrl('/not-found');
    }
    if (e.status === 401 || e.status === 403) {
      void router.navigateByUrl('/');
    }
    if (isPlatformBrowser(platformId)) {
      // Log only in browser
      console.error(e);
    }
    return throwError(() => e);
  });

  // Process redirects for startups with changed names
  /*const processRedirect = (event: HttpEvent<any>) => {
    if ((event instanceof HttpResponse) && (event.body?.redirect)) {
      rs.redirectToNewSlug(event.body?.redirect)
    }
  };*/

  // Cookies should be sent only on SSR side
  if (isPlatformBrowser(platformId)) {
    return next(req).pipe(
      checkCoins,
      processError
    ); //.pipe(tap(processRedirect));
  }

  const request = inject(REQUEST, {optional: true});
  const ssrCookies = request?.headers.get('cookie') || '';
  req = req.clone({withCredentials: true, headers: new HttpHeaders({cookie: ssrCookies})});
  /*  req = req.clone({
      withCredentials: true,
      setHeaders: {
        cookie: ssrCookies,
        credentials: 'include' // Ensure credentials are included
      }
    });*/

  return next(req).pipe(
    checkCoins,
    processError
  );//.pipe(tap(processRedirect));
}

const checkCoinsFromResponse = (auth: AuthService, response: any) => {
  if (response?.user?.points !== undefined && response?.user?.id === auth.user.id) {
    auth.user.points = response.user.points;
    auth.onCoinsChanged.emit(response.user.points);
  }
}
